import React, { createContext, useContext, useState, useEffect } from 'react';
import { whiteLabelService } from '../services/whiteLabelService';

const BrandingContext = createContext({});

export const useBranding = () => {
  const context = useContext(BrandingContext);
  if (!context) {
    throw new Error('useBranding must be used within BrandingProvider');
  }
  return context;
};

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({
    brandName: null,
    slogan: null,
    logoUrl: null
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load branding once when the provider mounts
  useEffect(() => {
    loadBranding();
  }, []);

  const loadBranding = async () => {
    try {
      setLoading(true);
      setError(null);
      const settings = await whiteLabelService?.getSettings();
      
      if (settings) {
        setBranding({
          brandName: settings?.brandName,
          slogan: settings?.slogan,
          logoUrl: settings?.logoUrl
        });
      } else {
        setBranding({
          brandName: null,
          slogan: null,
          logoUrl: null
        });
      }
    } catch (error) {
      console.error('Error loading branding:', error);
      setError(error);
      setBranding({
        brandName: null,
        slogan: null,
        logoUrl: null
      });
    } finally {
      setLoading(false);
    }
  };

  // Refresh branding manually if needed
  const refreshBranding = async () => {
    await loadBranding();
  };

  const value = {
    branding,
    loading,
    error,
    refreshBranding
  };

  return (
    <BrandingContext.Provider value={value}>
      {children}
    </BrandingContext.Provider>
  );
}